import React from "react";
import { useClientColyseus } from "../../Contexts/ClientColyseusContext";
import PageMultiplayer from "./PageMultiplayer";
import SpeedRoomGame from "./SpeedRoomGame";

const SpeedGame = () => {
  const { room } = useClientColyseus();
  if (room) return <SpeedRoomGame />;
  return <PageMultiplayer />;
};

export default SpeedGame;
